<div class="container-fluid  row_banner pb-5" style="overflow-x: hidden !important;">
    <app-header></app-header>
    <!-- Edditor  -->
    <div class="container">
        <div class="row  text-center justify-content-center" style=" align-content: center">
            <div class="col-lg-9 col-md-9 mb-4" id="footergrammartext">
                <h1 class="w-100 fnt-w600-40 " style="margin-top: 40px;">AI Business Plan Generator</h1>
                <span class="w-100 d-inline-block main_text mt-40">Produce in-depth, professional business reports that are clear, comprehensive, and aligned with industry standards.</span>
            </div>
        </div>


        <!-- Editor -->
        <div class="custom-card">
            <p class="text-left px-3" id="eFsubText2" [ngStyle]="{'color': color}" *ngIf="eFsubIF "
                style="margin-bottom: -10px;margin-top: -5px;"><i class="fas fa-check-circle" aria-hidden="true"
                    style="margin-right: 3px;"></i>{{eFsubText2}}
            </p>
            <form style="margin-top: 25px;">

                <div>
                    <div class="row" style="justify-content: space-between;">
                        <div class="col form-group ">
                            <label for="" style="align-items: left; font-weight: bold;display: flex;">Company/Brand
                                Overview * </label>
                            <input id="form_title" type="text" name="form_title" class="form-control bd-light"
                                placeholder="Example: XYZ Corp is a leading provider of AI-driven marketing solutions, focused on delivering personalized customer experiences.*"
                                onfocus="this.placeholder=''"
                                onblur="this.placeholder='Example: XYZ Corp is a leading provider of AI-driven marketing solutions, focused on delivering personalized customer experiences.*'"
                                required="true" value="" autocomplete="off" />
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label for="description" style="align-items: left; font-weight: bold;display: flex;">Marketing
                                Details *</label>
                            <textarea id="form_detailed" name="form_detailed" class="form-control bd-light" rows="1"
                                spellcheck="false" data-gramm="false"
                                placeholder="Example: Our marketing strategy includes a mix of digital advertising, content marketing, and partnerships to increase brand visibility and customer acquisition."></textarea>
                        </div>
                        <div class="col-md-6">
                            <label for="description" style="align-items: left; font-weight: bold;display: flex;">Competitor
                                Information *</label>
                            <textarea id="form_competitor" name="form_competitor" class="form-control bd-light" rows="1"
                                spellcheck="false" data-gramm="false"
                                placeholder="Example: Competitors include ABC Inc. and DEF Ltd., both of which have established market positions in AI-driven analytics and marketing solutions"
                                ></textarea>
                        </div>
                    </div>

                    <div class="">
                        <label for="description" style="align-items: left; font-weight: bold;display: flex;">Financial
                            Overview *</label>
                        <textarea id="form_financial" name="form_financial" class="form-control bd-light" rows="1"
                           spellcheck="false" data-gramm="false"
                            placeholder="Example: The company aims to achieve $10 million in revenue by the end of the fiscal year, with a focus on reducing operational costs by 15%."></textarea>
                    </div>

                </div>
                <div class="progress-loader-div">
                    <div class="progress-loader" *ngIf="loaderAlert"></div>
                  </div>
                <div class="container justify-content-center"
                    style="justify-content: center; align-items: center; display: flex; ">
                </div>
                <div class="input-group-append btn-submit-div" >
                    <button type="submit" class="btn btn-dark m-0 btn-submit" value="Submit" style="font-weight: bold;"
                        (click)="eFormSubmission($event)" >
                 Submit </button>
                        <button  *ngIf="output_display"   type="submit" class="btn btn-dark m-0 btn-submit "
                        (click)="reFreshWindow()"
                           >
                      Start New Search  </button>
                </div>

            </form>
            <div class="outputDisplay mt-3" *ngIf="output_display">
                <div class="outputtop">
                    
                        <p class="outputtopTxt">
                            Your business plan is below
                        </p>
                   
                    <div class="outputtopButton tooltipss"    (click)="copyToClipboard()"
                    role="button"
                    tabindex="0"
                    (keydown.enter)="copyToClipboard()" >
                    <span class="tooltiptext">Copy</span>
                    <span class="tooltiptext" id="copried_txt" *ngIf="copiedtext" >Copied</span>
                        <img src="../../assets/images/About us-assets/copy-frame.svg" alt=""
                            style="height: 18px;width: 18px;">
                        <p class="">Copy to clipboard</p>
                    </div>
                </div>
                <div style="padding: 20px;">
                    <!-- <div style="text-align: justify;" id="outputs"></div> -->
                    <div style="text-align: justify;" [innerHTML]="output"></div>

                </div>
            </div>
        </div>
    </div>
</div>

<!-- <a id="feedback" style="cursor: pointer;" title="Give Feedback" data-target=".feedback-modal-lg" data-toggle="modal">
    <img src="../../assets/images/feedback/give feedback.svg" alt="give-feedback" id="feedbackimg">
    <p id="feedbackP">Give Feedback</p>
</a>
<div class="modal modal-home  centered fade feedback-modal-lg text-center justify-content-center" data-backdrop="static"
    data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="feedback" aria-hidden="true">
    <div class="modal-dialog centered modal-lg">
        <div class="modal-content modal-content-feedback">
            <img class="modal-content-ai-img" data-dismiss="modal" (click)="clearfeedbackform()"
                src="../../assets/images/plagiarism checker/cross.svg" alt="cross-img" style="cursor: pointer;">
            <div style="display: inherit; cursor: pointer; justify-content: center;">
                <img src="../../assets/images/feedback/Group 24982.svg" alt="feedback" id="feedbackMIMG">
            </div>

         <p style="font-size: 28px;font-weight: 600;text-align: center; line-height: 35.28px;">Share your feedback</p>
                    <p style="font-size: 15px; font-weight: 500; text-align: center; line-height: 18.9px;"> Feel free To Share Your Feedback Us </p>
            <div style="display: inherit; cursor: pointer; justify-content: center;">
                <ul class="list-inline rating-list" *ngFor="let star of stars" style="display: inline-block"
                    style="display: inline-block">
                    <li #namebutton (click)="countStar(star)" [ngClass]="{'selected': (star <= selectedValue)}">
                        <i class="fa fa-star" style="font-size: 40px;"></i>
                </ul>
            </div>

            <form style="padding: 10px;">
                <div class="col-md-12 float-left p-1 p-md-2">
                    <div class="form-group m-0">
                        <label for="form_email"
                            style="font-size: 13px;font-weight: 500; text-align: left;display: block;">Email</label>
                        <input id="form_email" type="email" name="form_email" class="form-control bd-light" required
                            value="" placeholder="Your email address " onfocus="this.placeholder=''"
                            onblur="this.placeholder='Your email address'" style="" [(ngModel)]="form_email"
                            (change)="checkMail()" />
                    </div>
                </div>
                <div class="col-md-12 p-1 p-md-2">
                    <div class="form-group m-0">
                        <label for="form_email"
                            style="font-size: 13px;font-weight: 500; text-align: left;display: block;">Tell Us About
                            Your Experience </label>
                        <textarea id="form_message" name="form_message" class="form-control bd-light" required rows="6"
                            style="resize: none;"></textarea>
                    </div>
                </div>

                <p class="text-left px-3" id="eFsubText2" [ngStyle]="{'color': color}" *ngIf="eFsubIF "
                    style="margin-bottom: -10px;margin-top: -5px;"><i class="fas fa-check-circle" aria-hidden="true"
                        style="margin-right: 3px;"></i>{{eFsubText2}}
                </p>
                <p class="text-left " id="dangerAlerts" *ngIf="ifsub" [ngStyle]="{ color: color }"
                    style="margin-bottom: -10px;"><i class="fas fa-check-circle" aria-hidden="true"
                        style="margin-right: 3px;" *ngIf="ifsub"></i>
                    {{ dangerAlerts }}</p>
                <div *ngIf="showfeedbackloader" class="progress-feedback"></div>
                <br>
                <div class="col-md-12 p-2"><input type="submit" class="submit m-0 w-100" value="Send Feedback"
                        style="height: 50px; font-size: 20px; font-weight: bold;" (click)="eFormSubmission($event)" />
                </div>
            </form>
        </div>
    </div>
</div> -->
<a (click)="scrollToTop()" *ngIf="shouldShowButton" id="scroll-to-top" data-tooltip="Go to top">

  <app-icons-free-tools name="goToTopIcon" />
</a>

<app-footer></app-footer>
